import $ from 'jquery'

$('.js-signout').on('click', function(e) {
  var $t = $(this)
  $.ajax({
    crossDomain: true,
    type: 'POST',
    dataType: 'jsonp',
    url: wpscuba.ajax,
    data: {
      action: 'ajaxlogout'
    },
    success: function(data) {
      if (data.reload) {
        document.location.reload()
      }
    }
  })
  e.preventDefault()
})



// WEBPACK FOOTER //
// ./scripts/components/Signout.js